/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, August 3rd 2022, 5:19:42 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { UseAPIFormReturn } from "lib/api";
import { OSAPIForm, CardWidget } from "ui-widgets";
import HorizontalStepper, { HorizontalLinearStepperProps } from "ui-widgets/steppers/HorizontalStepper";

import { Container } from "@mui/material";

interface BasicFormWizardProps<TAPIFormData, TAPIFormResponse>
  extends Pick<HorizontalLinearStepperProps<TAPIFormData>, "steps">,
    Pick<React.ComponentProps<typeof Container>, "maxWidth"> {
  useAPIFormReturn: UseAPIFormReturn<TAPIFormData, TAPIFormResponse>;
  children?: React.ReactNode;
}

export const APIFormBasicWizard = <TAPIFormData, TAPIFormResponse>({
  useAPIFormReturn,
  steps,
  children,
  maxWidth = "sm",
}: BasicFormWizardProps<TAPIFormData, TAPIFormResponse>) => {
  // showSubmitButton is false because we want the stepper to have the submit button
  return (
    <OSAPIForm
      useAPIFormReturn={useAPIFormReturn}
      showSubmitButton={false}
      className="os-fullscreen-form"
      loaderType="circularInFront"
    >
      <Container maxWidth={maxWidth}>
        <CardWidget className="os-fullscreen-form-cardwidget">
          <HorizontalStepper<TAPIFormData>
            steps={steps}
            isSubmitting={useAPIFormReturn.isSendingDataToAPI}
            isSuccess={useAPIFormReturn.isSuccessfulAPIDataSend}
            isError={useAPIFormReturn.isAPIDataSendError}
            validationErrors={
              {
                ...useAPIFormReturn.useFormReturn.formState.errors,
                ...useAPIFormReturn.apiDataSendErrors,
              } as Record<keyof TAPIFormData, string>
            }
          />
          {children}
        </CardWidget>
      </Container>
    </OSAPIForm>
  );
};
